import firebase from 'firebase'
import router from '../router'

const state = {
	uid: '',
	is_installed_chrome_extension: false,
	is_nothanks_chrome_extension: false,

	is_ok_open_extension: false,
	is_show_extension_link: false
}
const mutations = {
	set_user (state, user) {
		state.uid = user.uid
	},
}
const actions = {
	logout ({ dispatch }) {
		dispatch('tabs/stopListener', {}, {root:true})
		dispatch('tags/stopListener', {}, {root:true})
		firebase.auth().signOut()
		router.push({ name: 'login'})
	},
	check_ok_open_extension({ state }, meta_data) {
		if (!meta_data) {
			state.is_ok_open_extension = true
			state.is_show_extension_link = true
			return
		}

		const is_installed = meta_data.is_installed_chrome_extension
		const is_nothanks = meta_data.is_nothanks_chrome_extension
		
		if ((is_installed == false || is_installed == undefined) && (is_nothanks == false || is_nothanks == undefined)) {
			state.is_ok_open_extension = true
		}

		if ((is_installed == false || is_installed == undefined)) {
			state.is_show_extension_link = true
		}
	},
	get_meta_data({ state, rootState, dispatch }) {
		const uid = state.uid
		const user_ref = rootState.db.collection('users').doc(uid)
		user_ref.get().then(function(doc) {
			if (doc.exists) {
				const meta_data = doc.data().meta_data
				dispatch('check_ok_open_extension', meta_data)
			} else {
				state.is_ok_open_extension = true
				state.is_show_extension_link = true
			}
		})
	},
	nothanks_extension({ state, rootState }) {
		const uid = state.uid
		const user_ref = rootState.db.collection('users').doc(uid)
		user_ref.update({"meta_data.is_nothanks_chrome_extension": true})
	}
}

export default {
	namespaced: true, state, mutations, actions
}
